import React, { useState, useEffect } from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  useTheme,
  IconButton,
  styled,
  CircularProgress,
  DialogActions,
  Stack,
  Grid,
  Tooltip,
  Paper,
  Alert,
  Tabs,
  Tab,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import {
  getJpExtensionCnForm,
  updateJpExtensionCn,
  updateJpExtensionCnForm,
  uploadFileJp,
  setSnackbarOpen,
  updateCnReimburse,
} from "src/redux/actions";
import {
  Delete,
  DoneOutline,
  Download,
  ExpandMore,
  Remove,
  Upload,
} from "@mui/icons-material";
import { DropzoneArea } from "material-ui-dropzone";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import CustomInput from "../CustomInput";
import CustomDatePicker from "../CustomDatePicker";
import { CustomAutoComplete } from "src/pages/admin/Setting/EditPanel/ComponentGroup";
import PropTypes from "prop-types";
import { inputNumberOnly } from "src/functions/inputNumberOnly";

const refActivity = [
  { activity: "interview-user", title: "Interview User" },
  { activity: "interview-division-head", title: "Interview Division Head" },
  { activity: "interview-direktur", title: "Interview Direktur" },
  { activity: "sign-contract", title: "Sign Contract" },
  { activity: "ground-test", title: "Ground Test" },
];

const refTransportasi = [
  { transportasi_keberangkatan: "bis", title: "Bis" },
  { transportasi_keberangkatan: "kereta-api", title: "Kereta Api" },
  { transportasi_keberangkatan: "pesawat", title: "Pesawat" },
];

const refTransportasiPlg = [
  { transportasi_kepulangan: "bis", title: "Bis" },
  { transportasi_kepulangan: "kereta-api", title: "Kereta Api" },
  { transportasi_kepulangan: "pesawat", title: "Pesawat" },
];

const refBank = [
  { kode_bank: "5360020", title: "BANK BCA SYARIAH" },
  { kode_bank: "4590011", title: "BANK BISNIS INTERNATIONAL" },
  { kode_bank: "4250018", title: "BANK BJB SYARIAH" },
  { kode_bank: "0570307", title: "BANK BNP PARIBAS INDONESIA" },
  { kode_bank: "4410010", title: "BANK BUKOPIN" },
];

const CustomDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": {
    backgroundColor: "rgb(255,255,255)",
    borderRadius: "1rem",
    border: "1px solid lightgrey",
    // maxWidth: "350px",
  },
}));

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const ModalUploadReimburse = ({ open, onClose, dataDetail }) => {
  const globalUrl =
    process.env.NODE_ENV !== "production"
      ? "http://localhost:5000"
      : window.location.origin;
  useTheme();
  const [loading, setLoading] = useState("content");
  const [inputPath, setInputPath] = useState("");
  const [loadingButton, setLoadingButton] = useState(false);
  const [data, setData] = useState([]);
  const [openAlert, setOpenAlert] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState("");
  const [form, setForm] = useState({
    ...dataDetail,
    activity_at: new Date(),
    tanggal_berangkat: new Date(),
    tanggal_pulang: new Date(),
  });
  const [value, setValue] = useState(0);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading("content");
    // const res = await getJpExtensionCnForm({
    //   candidate_id: dataDetail.candidate_id,
    // });
    // setData(res.data);
    setLoading("");
  };

  const handleUpload = async (files, key, old_file) => {
    if (files.length) {
      const validPdfTypes = ["application/pdf"];
      if (!validPdfTypes.includes(files[0].type)) {
        setSnackbarOpen("error", "Hanya file pdf yang diperbolehkan!");
        return;
      }

      setLoadingUpload(key);
      const resUpload = await uploadFileJp(files[0], old_file);
      if (typeof resUpload === "string") {
        setLoadingUpload("");
        setSnackbarOpen("error", resUpload);
        return;
      }
      setForm({
        ...form,
        [key]: resUpload?.data?.path,
      });
      setLoadingUpload("");
      setSnackbarOpen("success", "Data tersimpan");
    }
  };

  const handleDownload = () => {
    setTimeout(() => {
      var url = globalUrl + "/" + form?.ref_file_path + "?app=colagio";
      var link = document.createElement("a");
      link.href = url;
      link.click();
    }, 500);
  };

  const handleSendReimburse = async () => {
    form.input_file_path = inputPath;
    form.update_type = "upload-reimburse";
    setLoading("buttonApply");
    const bank = refBank.filter((b) => b.kode_bank === form.kode_bank)[0];
    form.bank = bank;
    console.log(form);

    await updateCnReimburse(form);
    setLoading("");
    onClose();
  };

  const handleBlur = (e) => {
    // dataDetail[e.target.name] = e.target.value;
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleDateChange = (val, name) => {
    setForm({ ...form, [name]: val });
  };

  const handleSelectAuto = async (val, key) => {
    setForm({ ...form, [key]: val[key] });
  };

  const handleChangeAccordion = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  if (loading === "content") return <CircularProgress />;

  return (
    <CustomDialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>
        <b>Upload Reimburse</b>
      </DialogTitle>
      <DialogContent sx={{ mx: 0, pt: "0.5rem !important" }}>
        <Accordion
          key={"activity"}
          expanded={expanded === `activity`}
          onChange={handleChangeAccordion(`activity`)}
          sx={{ borderRadius: "0.5rem", borderBottom: "none" }}
          square
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls={`activity`}
          >
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Aktivitas
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Stack>
              <CustomDatePicker
                label="Tanggal Aktivitas"
                onChange={handleDateChange}
                name="activity_at"
                value={form?.activity_at}
              />
              <CustomInput
                label="Lokasi Aktivitas"
                name="location_activity"
                onBlur={handleBlur}
              />
              <Typography
                sx={{ fontWeight: 500, fontSize: "14px", mb: "-8px" }}
              >
                Aktivitas
              </Typography>
              <CustomAutoComplete
                name="activity"
                optionsArr={refActivity || []}
                keyLabel={"title"}
                handleSelect={handleSelectAuto}
                style={{ marginBottom: "1rem" }}
                disabled
                value={
                  refActivity.filter((u) => u.activity === form.activity)[0]
                }
              />
            </Stack>
          </AccordionDetails>
        </Accordion>
        <Accordion
          key={"keberangkatan"}
          expanded={expanded === `keberangkatan`}
          onChange={handleChangeAccordion(`keberangkatan`)}
          sx={{ borderRadius: "0.5rem", borderBottom: "none" }}
          square
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls={`keberangkatan`}
          >
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Penggantian Keberangkatan
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Stack>
              <CustomDatePicker
                label="Tanggal Berangkat"
                onChange={handleDateChange}
                name="tanggal_berangkat"
                value={form?.tanggal_berangkat}
              />
              <CustomInput
                label="Lokasi Keberangkatan"
                name="lokasi_keberangkatan"
                onBlur={handleBlur}
              />
              <CustomInput
                label="Tujuan Keberangkatan"
                name="tujuan_keberangkatan"
                onBlur={handleBlur}
              />
              <Typography
                sx={{ fontWeight: 500, fontSize: "14px", mb: "-8px" }}
              >
                Transportasi Keberangkatan
              </Typography>
              <CustomAutoComplete
                name="transportasi_keberangkatan"
                optionsArr={refTransportasi || []}
                keyLabel={"title"}
                handleSelect={handleSelectAuto}
                style={{ marginBottom: "1rem" }}
              />
              <CustomInput
                label="Harga Tiket Keberangkatan"
                name="harga_tiket_keberangkatan"
                onBlur={handleBlur}
                onKeyDown={inputNumberOnly}
              />
            </Stack>
          </AccordionDetails>
        </Accordion>
        <Accordion
          key={"kepulangan"}
          expanded={expanded === `kepulangan`}
          onChange={handleChangeAccordion(`kepulangan`)}
          sx={{ borderRadius: "0.5rem", borderBottom: "none" }}
          square
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls={`kepulangan`}
          >
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Penggantian Kepulangan
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Stack>
              <CustomDatePicker
                label="Tanggal Pulang"
                onChange={handleDateChange}
                name="tanggal_pulang"
                value={form?.tanggal_pulang}
              />
              <CustomInput
                label="Lokasi Kepulangan"
                name="lokasi_kepulangan"
                onBlur={handleBlur}
              />
              <CustomInput
                label="Tujuan Kepulangan"
                name="tujuan_kepulangan"
                onBlur={handleBlur}
              />
              <Typography
                sx={{ fontWeight: 500, fontSize: "14px", mb: "-8px" }}
              >
                Transportasi Kepulangan
              </Typography>
              <CustomAutoComplete
                name="transportasi_kepulangan"
                optionsArr={refTransportasiPlg || []}
                keyLabel={"title"}
                handleSelect={handleSelectAuto}
                style={{ marginBottom: "1rem" }}
              />
              <CustomInput
                label="Harga Tiket Kepulangan"
                name="harga_tiket_kepulangan"
                onBlur={handleBlur}
                onKeyDown={inputNumberOnly}
              />
            </Stack>
          </AccordionDetails>
        </Accordion>
        <Accordion
          key={"bank"}
          expanded={expanded === `bank`}
          onChange={handleChangeAccordion(`bank`)}
          sx={{ borderRadius: "0.5rem", borderBottom: "none" }}
          square
        >
          <AccordionSummary expandIcon={<ExpandMore />} aria-controls={`bank`}>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Informasi Bank
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Stack>
              <CustomInput
                label="No Rekening"
                name="no_rekening"
                onBlur={handleBlur}
              />
              <Typography
                sx={{ fontWeight: 500, fontSize: "14px", mb: "-8px" }}
              >
                Nama Bank
              </Typography>
              <CustomAutoComplete
                name="kode_bank"
                optionsArr={refBank || []}
                keyLabel={"title"}
                handleSelect={handleSelectAuto}
                style={{ marginBottom: "1rem" }}
              />
              <CustomInput
                label="Nama di Bank (Jika ada title Tn/Ny/Sdr/Sdri) mohon dicantumkan"
                name="nama_di_bank"
                onBlur={handleBlur}
                placeholder="Tn. Abdul"
              />
              <CustomInput
                disabled
                name="total_penggantian"
                label="Total Penggantian"
                value={
                  parseInt(form.harga_tiket_keberangkatan || 0) +
                  parseInt(form.harga_tiket_kepulangan || 0)
                }
              />
            </Stack>
          </AccordionDetails>
        </Accordion>
        <Accordion
          key={"document"}
          expanded={expanded === `document`}
          onChange={handleChangeAccordion(`document`)}
          sx={{ borderRadius: "0.5rem", borderBottom: "none" }}
          square
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls={`document`}
          >
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Dokumen Kelengkapan
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Stack>
              <Button
                component="label"
                variant="outlined"
                disabled={loadingUpload === "rekening_path"}
                startIcon={
                  loadingUpload === "rekening_path" ? (
                    <CircularProgress />
                  ) : form.rekening_path ? (
                    <DoneOutline color="success" />
                  ) : null
                }
              >
                Buku Rekening
                <span style={{ fontSize: "10px" }}>{` (pdf)`}</span>
                <VisuallyHiddenInput
                  type="file"
                  accept="application/pdf"
                  onChange={(e) =>
                    handleUpload(
                      e.target.files,
                      "rekening_path",
                      dataDetail?.rekening_path,
                    )
                  }
                />
              </Button>
              <Button
                component="label"
                variant="outlined"
                disabled={loadingUpload === "boarding_pass_path"}
                startIcon={
                  loadingUpload === "boarding_pass_path" ? (
                    <CircularProgress />
                  ) : form.boarding_pass_path ? (
                    <DoneOutline color="success" />
                  ) : null
                }
              >
                Boarding Pass
                <span style={{ fontSize: "10px" }}>{` (pdf)`}</span>
                <VisuallyHiddenInput
                  type="file"
                  accept="application/pdf"
                  onChange={(e) =>
                    handleUpload(
                      e.target.files,
                      "boarding_pass_path",
                      dataDetail?.boarding_pass_path,
                    )
                  }
                />
              </Button>
              <Button
                component="label"
                variant="outlined"
                disabled={loadingUpload === "tiket_path"}
                startIcon={
                  loadingUpload === "tiket_path" ? (
                    <CircularProgress />
                  ) : form.tiket_path ? (
                    <DoneOutline color="success" />
                  ) : null
                }
              >
                Tiket Perjalanan
                <span style={{ fontSize: "10px" }}>{` (pdf)`}</span>
                <VisuallyHiddenInput
                  type="file"
                  accept="application/pdf"
                  onChange={(e) =>
                    handleUpload(
                      e.target.files,
                      "tiket_path",
                      dataDetail?.tiket_path,
                    )
                  }
                />
              </Button>
              <Tooltip
                title="jika nomor rekening bukan atas nama Calon
                Karyawan"
              >
                <Button
                  component="label"
                  variant="outlined"
                  disabled={loadingUpload === "surat_kuasa_path"}
                  startIcon={
                    loadingUpload === "surat_kuasa_path" ? (
                      <CircularProgress />
                    ) : form.surat_kuasa_path ? (
                      <DoneOutline color="success" />
                    ) : null
                  }
                >
                  Surat Kuasa Rekening
                  <span style={{ fontSize: "10px" }}>{` (pdf)`}</span>
                  <VisuallyHiddenInput
                    type="file"
                    accept="application/pdf"
                    onChange={(e) =>
                      handleUpload(
                        e.target.files,
                        "surat_kuasa_path",
                        dataDetail?.surat_kuasa_path,
                      )
                    }
                  />
                </Button>
              </Tooltip>
            </Stack>
          </AccordionDetails>
        </Accordion>
        {dataDetail?.validate_result === "1" && (
          <Stack sx={{ mt: "1rem" }}>
            <CustomInput
              label="Catatan Revisi"
              name="validation_notes"
              value={dataDetail?.validation_notes}
              disabled
              multiline
              rows={7}
            />
          </Stack>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Batal</Button>
        {loading === "buttonApply" ? (
          <CircularProgress />
        ) : (
          <Button
            variant="contained"
            onClick={handleSendReimburse}
            disabled={loading === "buttonApply"}
          >
            Simpan & Kirim
          </Button>
        )}
      </DialogActions>
    </CustomDialog>
  );
};

export default ModalUploadReimburse;
